import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || "default-secret";

// Encrypt object → URL-safe string (Base64URL)
export function encryptObject(obj: object): string {
    const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(obj),
        SECRET_KEY
    ).toString();

    // Convert Base64 → Base64URL
    return ciphertext
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
}

// Decrypt URL-safe string → object
export function decryptObject(token: string): any {
    // Convert Base64URL → Base64
    const base64 = token
        .replace(/-/g, "+")
        .replace(/_/g, "/")
        .padEnd(token.length + (4 - (token.length % 4)) % 4, "=");

    const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) throw new Error("Invalid token or decryption failed");
    return JSON.parse(decrypted);
}